<template>
  <div class="pt20">
    <div class="back" @click="back()">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('organization.external.add.back') }}</span>
    </div>
    <h4>{{ id ? $t('organization.external.add.edit') : $t('organization.external.add.create') }}</h4>
    <a-form :form="form" layout="vertical" autocomplete="off">
      <div class="title">{{ $t('organization.external.add.basicInfo') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.schoolName')" :colon="false">
          <a-input
            maxLength="13"
            minLength="8"
            :placeholder="$t('organization.external.add.schoolNamePlaceholder')"
            v-decorator="['schoolName', { rules: [{ required: true, message: $t('organization.external.add.schoolNameRequired') }] }]"
          />
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.schoolLocation')" :colon="false">
          <a-select
            v-decorator="['schoolLocation', { rules: [{ required: true, message: $t('organization.external.add.schoolLocationRequired') }] }]"
            :placeholder="$t('organization.external.add.schoolLocationPlaceholder')"
          >
            <a-select-option value="1">{{ $t('organization.external.add.domestic') }}</a-select-option>
            <a-select-option value="2">{{ $t('organization.external.add.foreign') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.schoolCountry')" :colon="false">
          <a-select
            v-decorator="['schoolCountry', { rules: [{ required: true, message: $t('organization.external.add.schoolCountryRequired') }] }]"
            :placeholder="$t('organization.external.add.schoolCountryPlaceholder')"
            showSearch
            :filterOption="filterCountryOption"
          >
            <a-select-option v-for="country in countryList" :key="country.value" :value="country.value">
              {{ country.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.employeeNumber')" :colon="false">
          <a-input
            v-decorator="['employeeNumber', { rules: [{ required: true, message: $t('organization.external.add.employeeNumberRequired') }] }]"
            :placeholder="$t('organization.external.add.employeeNumberPlaceholder')"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.name')" :colon="false">
          <a-input
            maxLength="20"
            :placeholder="$t('organization.external.add.namePlaceholder')"
            v-decorator="['name', { rules: [{ required: true, message: $t('organization.external.add.nameRequired') }] }]"
          />
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.username')" :colon="false">
          <a-input
            maxLength="13"
            :addon-after="shortName"
            :placeholder="$t('organization.external.add.usernamePlaceholder')"
            v-decorator="[
              'username',
              { rules: [{ required: true, message: $t('organization.external.add.usernameRequired') }, { validator: checkName }] }
            ]"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.password')" :colon="false">
          <a-input
            maxLength="13"
            autocomplete="new-password"
            :type="!passwordFlag ? 'password' : 'text'"
            v-decorator="['password', { rules: [{ required: isRequired, message: $t('organization.external.add.passwordRequired') }] }]"
            :placeholder="$t('organization.external.add.passwordPlaceholder')"
          >
            <img
              @click="passwordFlag = true"
              v-if="!passwordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="passwordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.confirmPassword')" :colon="false">
          <a-input
            maxLength="13"
            autocomplete="new-password"
            :type="!repasswordFlag ? 'password' : 'text'"
            :placeholder="$t('organization.external.add.confirmPasswordPlaceholder')"
            v-decorator="[
              'repassword',
              { rules: [{ required: isRequired, message: $t('organization.external.add.confirmPasswordRequired') }, { validator: compareToFirstPassword }] }
            ]"
          >
            <img
              @click="repasswordFlag = true"
              v-if="!repasswordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="repasswordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.gender')" :colon="false">
          <a-select allowClear v-decorator="['gender']" :placeholder="$t('organization.external.add.genderPlaceholder')">
            <a-select-option value="1">{{ $t('organization.external.add.male') }}</a-select-option>
            <a-select-option value="2">{{ $t('organization.external.add.female') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.phone')" :colon="false">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [{ validator: validatePhone }]
              }
            ]"
            :placeholder="$t('organization.external.add.phonePlaceholder')"
            @input="handlePhoneInput"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('organization.external.add.userRole')" :colon="false">
          <a-select allowClear v-decorator="['employeeType', { rules: [{ required: true, message: $t('organization.external.add.userRoleRequired') }] }]" :placeholder="$t('organization.external.add.userRolePlaceholder')">
            <a-select-option value="1">{{ $t('organization.external.add.teacher') }}</a-select-option>
            <a-select-option value="2">{{ $t('organization.external.add.student') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('organization.external.add.profession')" :colon="false">
          <a-cascader
            :options="professionList"
            @change="onChange"
            v-decorator="['profession']"
            :placeholder="$t('organization.external.add.professionPlaceholder')"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.enrollmentYear')" :colon="false">
          <a-select
            v-decorator="['enrollmentYear', { rules: [{ required: true, message: $t('organization.external.add.enrollmentYearRequired') }] }]"
            :placeholder="$t('organization.external.add.enrollmentYearPlaceholder')"
          >
            <a-select-option v-for="year in yearList" :key="year" :value="year">
              {{ year }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('organization.external.add.className')" :colon="false">
          <a-input minLength="2" maxLength="20" v-decorator="['class']" :placeholder="$t('organization.external.add.classNamePlaceholder')" />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('organization.external.add.department')" :colon="false">
          <a-input maxLength="20" v-decorator="['department']" :placeholder="$t('organization.external.add.departmentPlaceholder')" />
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.email')" :colon="false">
          <a-input
            maxLength="50"
            v-decorator="[
              'email',
              {
                rules: [{ validator: validateEmail }]
              }
            ]"
            :placeholder="$t('organization.external.add.emailPlaceholder')"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.unit')" :colon="false">
          <a-input
            v-decorator="[
              'organization',
              {
                rules: [{ required: true, message: $t('organization.external.add.unitRequired') }]
              }
            ]"
            :placeholder="$t('organization.external.add.unitPlaceholder')"
          />
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.idCard')" :colon="false">
          <a-input
            v-decorator="[
              'idCardNumber',
              {
                rules: [{ required: true, message: $t('organization.external.add.idCardRequired') }, { validator: validateIdCard }]
              }
            ]"
            :placeholder="$t('organization.external.add.idCardPlaceholder')"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('organization.external.add.status')" :colon="false">
          <a-select
            allowClear
            v-decorator="[
              'status',
              {
                rules: [{ required: true, message: $t('organization.external.add.statusRequired') }]
              }
            ]"
            :placeholder="$t('organization.external.add.statusPlaceholder')"
          >
            <a-select-option value="1">{{ $t('organization.external.add.enabled') }}</a-select-option>
            <a-select-option value="0">{{ $t('organization.external.add.disabled') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('organization.external.add.address')" :colon="false">
          <a-input
            v-decorator="[
              'address',
              {
                rules: [{ required: true, message: $t('organization.external.add.addressRequired') }]
              }
            ]"
            :placeholder="$t('organization.external.add.addressPlaceholder')"
          />
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('organization.external.add.save') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import { getAdminOrgList } from '@/api/lesson'
import { externalSave, externalDetail } from '@/api/admin'
import cookie from 'js-cookie'
import md5 from 'md5'

export default {
  data() {
    return {
      id: undefined,
      isRequired: true,
      passwordFlag: false,
      repasswordFlag: false,
      shortName: '@' + cookie.getJSON('user_infor').username.split('@')[1],
      professionList: [],
      form: this.$form.createForm(this),
      emailSuffixes: [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@gmail.com',
        '@hotmail.com',
        '@outlook.com',
        '@yahoo.com',
        '@sohu.com'
      ],
      countryList: [
        { value: '中国', label: '中国' },
        { value: '美国', label: '美国' },
        { value: '英国', label: '英国' },
        { value: '日本', label: '日本' },
        { value: '韩国', label: '韩国' }
        // 可以继续添加更多国家
      ],
      yearList: this.generateYearList()
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    async professionMapHttp() {
      try {
        const res = await getAdminOrgList()
        if (res.code === 200) {
          this.professionList = res.data.list.map(college => ({
            value: college.id,
            label: college.name,
            children: college.child.map(department => ({
              value: department.id,
              label: department.name,
              children: department.child.map(profession => ({
                value: profession.id,
                label: profession.name
              }))
            }))
          }))
        }
      } catch (error) {
        console.error('获取专业列表失败:', error)
        this.$message.error(this.$t('organization.external.add.getProfessionListFailed'))
      }
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let pd = ''
          if (
            values.password !== '' &&
            values.password !== undefined &&
            values.repassword !== undefined &&
            values.repassword !== ''
          ) {
            pd = md5(values.password)
          } else if (
            values.password !== '' &&
            values.password !== undefined &&
            (values.repassword === undefined || values.repassword === '')
          ) {
            this.$message.error(this.$t('organization.external.add.confirmPasswordRequired'))
            return
          } else {
            pd = ''
          }
          const submitData = {
            ...values,
            username: values.username + this.shortName,
            password: pd,
            collegeId: values.profession ? values.profession[0] : undefined,
            departmentId: values.profession ? values.profession[1] : undefined,
            professionId: values.profession ? values.profession[2] : undefined,
            id: this.id
          }
          externalSave(submitData).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('organization.external.add.saveSuccess'))
              this.back()
            }
          })
        }
      })
    },
    checkName(rule, value, callback) {
      if (/.*[一-龥]+.*$/.test(value)) {
        callback(this.$t('organization.external.add.noChineseAllowed'))
      } else {
        callback()
      }
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(this.$t('organization.external.add.passwordMismatch'))
      } else {
        callback()
      }
    },
    validatePhone(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      const phoneRegex = /^1[3-9]\d{9}$/
      if (value && !phoneRegex.test(value)) {
        callback(this.$t('organization.external.add.invalidPhone'))
      } else {
        callback()
      }
    },
    handlePhoneInput(e) {
      const value = e.target.value
      if (value && !/^\d*$/.test(value)) {
        e.target.value = value.replace(/\D/g, '')
      }
    },
    validateEmail(rule, value, callback) {
      if (!value) {
        callback()
        return
      }

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
      if (!emailRegex.test(value)) {
        callback(this.$t('organization.external.add.invalidEmail'))
        return
      }

      const atIndex = value.indexOf('@')
      const emailSuffix = value.substring(atIndex)
      if (!this.emailSuffixes.includes(emailSuffix)) {
        callback(this.$t('organization.external.add.useCommonEmailDomain'))
        return
      }

      callback()
    },
    onChange(value) {
      console.log(value)
    },
    getExternalDetail() {
      externalDetail({ id: this.id }).then(res => {
        if (res.code === 200) {
          for (const key in res.data) {
            if (res.data[key] === '0' || res.data[key] === '') {
              res.data[key] = undefined
            }
          }
          const formData = {
            ...res.data,
            profession: !res.data.professionId
              ? ''
              : [res.data.collegeId, res.data.departmentId, res.data.professionId],
            username: res.data.username.split('@')[0],
            schoolName: res.data.schoolName,
            schoolLocation: res.data.schoolLocation,
            country: res.data.country,
            studentNumber: res.data.studentNumber,
            enrollmentYear: res.data.enrollmentYear,
            idCard: res.data.idCard,
            company: res.data.company,
            address: res.data.address
          }
          this.form.setFieldsValue(formData)
        }
      })
    },
    generateYearList() {
      const currentYear = new Date().getFullYear()
      const years = []
      for (let year = currentYear; year >= 1990; year--) {
        years.push(year.toString())
      }
      return years
    },
    filterCountryOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    validateIdCard(rule, value, callback) {
      if (!value) {
        callback()
        return
      }

      // 身份证号码验证规则
      const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (!idCardReg.test(value)) {
        callback(this.$t('organization.external.add.invalidIdCard'))
        return
      }

      callback()
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.professionMapHttp()
    if (this.id) {
      setTimeout(() => {
        this.getExternalDetail()
        this.isRequired = false
      }, 100)
    }
  }
}
</script>

<style lang="less" scoped>
// 复用学生添加页面的样式
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}

.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;

  img {
    height: 10px;
    margin-right: 9px;
  }
}

/deep/ .ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;

    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }

  .list {
    display: flex;
    padding-right: 200px;

    .ant-form-item-label label {
      color: #000000;
    }

    .ant-form-item {
      width: 50%;
      padding-left: 45px;

      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }

    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;

      img {
        width: 23px;
        height: 23px;
        opacity: 0.3;
      }
    }

    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }

    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
  }

  .submit-button {
    width: 100%;
    text-align: center;
    margin-top: 100px;
  }
}

/deep/ .anticon {
  color: #d5d5d5 !important;
}
</style>
